import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { PushNotificationsService } from 'angular2-notifications';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.css']
})
export class AddressesComponent implements OnInit {
  loggedinUser: any = [];
  addresses: any = [];
  errorMessage: any = [];
  newAddress: any = [];
  colonies: any = [];
  finalAddress = {};
  constructor(private _sanitizer: DomSanitizer, private router: Router, private AddressService: WebApiObservableService, private _pushNotifications: PushNotificationsService) {
    _pushNotifications.requestPermission();
  }

  ngOnInit() {
    this.loggedinUser = JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
    let token = localStorage.getItem('AUTH_TOKEN');
    $('.spin').addClass('loading');

    this.AddressService.getServiceForSearch('/colonies', 'pagesize', '700')
      .subscribe(
      result => {
        this.colonies = result.items;
      },
      error => {
        this.errorMessage = error.message;
      }
      );
    this.AddressService
      .searchaddress('/customeraddressservices', 'customer_id', this.loggedinUser.id, token)
      .subscribe(
      result => {
        this.addresses = result.items;
        $('.spin').removeClass('loading');
      },
      error => {
        $('.spin').removeClass('loading');
        this.errorMessage = error.message;
      }
      );
  }


  openAccount() {
    this.router.navigate(["edit-account"]);
  }

  openOrders() {
    this.router.navigate(["my-account"]);
  }

  autocompleListFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.area}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  editAddress(myModal, address) {
    myModal.open();
  
    this.newAddress = address;

  }

  updateAddress(myModal, id) {
    $('.editspin').addClass('loading');
    let token = localStorage.getItem('AUTH_TOKEN');
    this.finalAddress = {
      address: this.newAddress.address,
      area: this.newAddress.area,
      colony_id: this.newAddress.colony.id,
      customer_id: this.newAddress.customer_id,
      landmark: this.newAddress.landmark,
      street: this.newAddress.street
    };

    this.AddressService
      .updateAddress('/customeraddressservices/' + id, this.finalAddress, token)
      .subscribe(
      result => {
        myModal.close();
        $('.editspin').removeClass('loading');
        alert('Address Updated');
        let options = {
          body: 'Address Updated',
          icon: 'http://test.eatasiafood.com/uploads/logo/logo.png',
        }
        let notify = this._pushNotifications.create('Success', options).subscribe(
        );

      },
      error => {
        $('.editspin').removeClass('loading');
        this.errorMessage = <any>error
      }
      );
  }
}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/addresses/addresses.component.ts